<template>
    <PRICE_VAT_TIP :showVATTip=showVATTip :currentCountry="currentCountry" />
</template>
<script>
import { get } from 'lodash';

export default {
  name: 'priceVATTip',
  computed: {
    currentCountry () {
      return get(window.newBillingConfig, 'currentCountry', '')
    }
  },
};
</script>

